export const addIcon = {
    iconName: "AddTo",
    cursor: "pointer",
  };

export const searchInputStyle = {
    root: {
      width: "210px",
    },
    field: {
      borderRadius: "7px",
    },
};

export const checkboxFilterStyle = {
  root: {
    margin: "10px 0",
  },
  text: {
    fontWeight: "400",
    fontSize: "14px"
  },
  checkbox: {
  },
};

export const searchFilterStyle = {
  root: {
    background: "transparent",
  },
};

export const searchStyle = {
  root: {
    background: "transparent",
    border: "1px solid rgba(200, 198, 196, 0.3)",
    borderRadius: "5px",
  },
};

export const triageStackStyles = {
  minHeight: "100px",
  // width: "333px",
  alignItems: "center",
  position: "relative",
  justifyContent:"center",
  height: "calc(100% - 30px)",
  margin: "15px 0",
  cursor: "text"
};

export const triageBoxStackStyle = {
  //minHeight: "90px",
  height: "100%",
  // width: "333px",
  borderRadius: "5px",
  alignItems: "center",
};

export const triageDetailsStackStyle = {
  width: "166px",
  justifyContent: "center",
  height: "100%",
};

export const priorityStackStyle = {
  alignItems: "center",
  justifyContent: "center",
  // borderBottom: "1px solid #3B3A39"
};

export const priorityTextStyle = {
  // Inset as padding (not margin) with border-box sizing so the badge can be
  // capped at the column width: a long, firm-configurable priority label then
  // ellipsis inside the column instead of overflowing it.
  padding: "0 7px",
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const remarkTextStyle = {
  width: "146px",
  fontSize: "12px",
  margin: "auto",
  textAlign: "center",
  lineHeight: "16px",
};

export const verticalLine = {
  width: "1px",
  backgroundColor: "#C8C6C4",
  height: "80px",
};

export const annotationDivStackStyle = {
  width: "166px",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  paddingLeft: "15px",
  paddingRight: "15px",
  // paddingTop: "15px",
  // paddingBottom: "20px",
  flex: 1,
  transition: "0.3s ease-in-out"
};

export const annotationReportedDivStackStyle = {
  width: "166px",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  paddingLeft: "12px",
  paddingRight: "12px",
  // paddingTop: "15px",
  paddingBottom: "20px",
  flex: 1,
  transition: "0.3s ease-in-out"
};

export const annotationStyle = {
  width: "22px",
  height: "16px",
  borderRadius: "5px",
  fontSize: "8px",
  fontWeight: "bolder",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "5px",
};

export const annotationTextStyle = {
  
};

export const annotationStackStyle = {
  alignItems: "center",
  lineHeight: "3px",
  // padding: "3px 0px"
};

export const expandButtonStyle = {
  fontSize: "11px",
  paddingRight: "4px",
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '16px',
  color: '#848484',
  marginTop: "3px",
  alignSelf: "center",
};

export const statusStyle = {
};